module.exports = __webpack_public_path__ + "img/sv27.ec8325e6.svg";